<div class="order-edit-detail-container" id="materials">
  <!-- only show if there are ordered materials -->
  <app-flow-edit-material
    *ngIf="editMaterial"
    [saving]="panelStatus.busy"
    [definitions]="definitions"
    [lineItemValidation]="lineItemValidation"
    [material]="editMaterial"
    [materialTypes]="materialTypes"
    [panelStatus]="panelStatusMaterial"
    (nextClicked)="nextClickedFn()"
    (saveMaterialClicked)="saveMaterialClickedFn($event)"
    (showQuantityModal)="showQuantityModal.emit($event)"
    [maxAmountPopupIsShown]="maxAmountPopupIsShown"
    (resetMaxAmountPopup)="resetMaxAmountPopup.emit($event)"
  >
  </app-flow-edit-material>

  <app-flow-material-lines
    [materials]="florderDetail.materials"
    [definitions]="definitions"
    [sort]="sort"
    titlePart="MATERIAL_LINES"
    [panelStatus]="panelStatus"
    (editMaterialClicked)="editMaterialClicked($event)"
    (removeMaterialClicked)="removeMaterialClicked.emit($event)"
    (sortChange)="sortChange.emit($event)"
  >
  </app-flow-material-lines>

  <div *ngIf="!disputeQuantitiesValid" class="error-message dispute-error">{{ 'FLOWS.NOTIFICATIONS.DISPUTE_QUANTITIES_INVALID' | translate }}</div>

  <div class="form-container" *ngIf="panelStatus.isEdit && panelStatus.showNext">
    <div class="hr"></div>
    <div class="buttons save-button" *ngIf="panelStatus.isEdit">
      <div class="hr-thick"></div>
      <eps-button
        type="link"
        *ngIf="panelStatus.isNew"
        (buttonClick)="cancelClicked.emit()"
        label="SHARED.BUTTONS.CANCEL"
      ></eps-button>
      <eps-button
        (buttonClick)="goBackClicked.emit()"
        label="SHARED.BUTTONS.BACK"
        *ngIf="panelStatus.showBack"
      ></eps-button>
      <eps-button
        [disabled]="!isValid()"
        (buttonClick)="nextClickedFn()"
        [label]="panelStatus.isNew ? 'FLOWS.DETAILS.BUTTONS.NEXT' : 'SHARED.BUTTONS.SAVE'"
        [submit]="isValid() && (nextOnEnterPressed$ | async)"
      ></eps-button>
    </div>
  </div>
</div>
